import { CARD_BODY_COLUMN_DESCRIPTION } from '../../../helpers/card-body-column-description'
import { useContext } from 'react'
import { ClientContext } from '../../../context/client-context'

export const WhatsappHelpWarningAlert = () => {
  const { isMiTienda } = useContext(ClientContext)

  const whatsappHelpApi = isMiTienda
    ? 'https://wa.me/message/4T2Z7NCJI4MGK1'
    : 'https://api.whatsapp.com/send/?phone=5218182528316&text=%C2%A1Hola%20H-E-B!&type=phone_number&app_absent=0'

  return (
    <div className={'alert alert-warning show d-flex ps-0 pb-0 pt-0 ' + CARD_BODY_COLUMN_DESCRIPTION} role="alert">
      <img alt="Warning" style={{ padding: '8px' }} src="/assets/warning-icon.svg"/>
      <span className="vertical-divider"></span>
      <span className="text-alert alert-message whatsapp-alert-message">
        <b>¿Estas experimentando dificultades?</b>
        <a href={whatsappHelpApi}>Contáctanos por whatsapp.</a>
      </span>
    </div>
  )
}
